import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DOMAINS = [
  { img: '/images/generated/skill-service-2026.jpg', icon: 'ri-goblet-line' },
  { img: '/images/generated/skill-observation-2026.jpg', icon: 'ri-archive-drawer-line' },
  { img: '/images/generated/clinic-hero-x1.jpg', icon: 'ri-shield-user-line' },
  { img: '/images/generated/master-crisis-2026.jpg', icon: 'ri-compass-3-line' },
];

function splitParagraphs(text: string): string[] {
  return text
    .split(/(?:\r?\n){2,}/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export default function FourDomains() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {splitParagraphs(t('butlerTrainingSchool.domains.label')).map((para, i) => (
            <p key={i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              {para}
            </p>
          ))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerTrainingSchool.domains.title')}
          </h2>
          {splitParagraphs(t('butlerTrainingSchool.domains.titleEn')).map((para, i) => (
            <p key={i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
              {para}
            </p>
          ))}
          <div className="gold-line mx-auto mb-6"></div>
          {splitParagraphs(t('butlerTrainingSchool.domains.lead')).map((para, i) => (
            <p key={i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[680px] mx-auto">
              {para}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {DOMAINS.map((domain, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 overflow-hidden cursor-default"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={domain.img}
                  alt={t(`butlerTrainingSchool.domains.${idx}.imgAlt`)}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                    <i className={`${domain.icon} text-accent-500 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em]">
                    {t(`butlerTrainingSchool.domains.${idx}.title`)}
                  </h3>
                </div>
                {splitParagraphs(t(`butlerTrainingSchool.domains.${idx}.desc`)).map((para, i) => (
                  <p key={i} className="text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-[820px] mx-auto mt-12 text-center">
          {splitParagraphs(t('butlerTrainingSchool.domains.note')).map((para, i) => (
            <p key={i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-4">
              {para}
            </p>
          ))}
          <Link
            to="/curriculum"
            className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            <span>{t('butlerTrainingSchool.domains.noteLink')}</span>
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
